<template>
  <aha-modal
    :title="$i18nPresenter.t('The Quiz will not have a winner!')"
    @hide="$emit('hideModal')"
  >
    <div>
      {{ $i18nPresenter.t('Reveal the winner of the Quiz by adding a leaderboard after the last question.') }}
    </div>
    <template #action>
      <aha-button
        v-if="!showViewerCannot"
        icon-name="add"
        @click="$emit('addQuiz')"
        has-margin-right
      >
        {{ $i18nPresenter.t('Add leaderboard') }}
      </aha-button>
      <aha-link v-else @click="$emit('hideModal')" has-margin-right>
        <span class="font-bold">{{ $i18nPresenter.t('Cancel') }}</span>
      </aha-link>
      <aha-button
        :variant="!showViewerCannot ? 'base' : 'primary'"
        @click="$emit('hideModalAndMaybePresent')"
      >
        {{ $i18nPresenter.t('Present anyway') }}
      </aha-button>
    </template>
  </aha-modal>
</template>
<script>
import { mapState } from 'vuex'
import constants from '@/constant'

export default {
  name: 'EditorHeaderPresentingNoLeaderboard',
  computed: {
    ...mapState({
      canEditPresentation: (state) => state.canEditPresentation,
      presentation: (state) => state.presentation,
      currentUser: (state) => state.currentUser,
    }),
    showViewerCannot() {
      // if (this.presentation.accountId === this.currentUser.accountId) {
      //   return this.currentUser.accountRole === constants.role.VIEWER
      // }
      if (this.presentation.permissions === undefined) {
        return false
      }
      return !this.presentation.permissions.includes(constants.permissions.RENAME_PRESENTATION)
    },
  },
}
</script>
